import EA from '../helpers/init';
import Swiper from 'swiper';

export default EA.Methods.aboutVoiceSwiper = ($this) => {
    const swiperEl = $this.querySelector('.about-voice-swiper');

    const swiper = new Swiper( swiperEl, {
        speed: 1000,
        slidesPerView: 'auto',
        spaceBetween: 0
    });

    function updateSwiperTouch(swiperInstance) {
        const slideWidth = swiperInstance.slides[0].offsetWidth || 1;
        const visibleSlides = Math.floor(swiperInstance.width / slideWidth);

        if (swiperInstance.slides.length <= visibleSlides) {
            swiperInstance.allowTouchMove = false;
        } else {
            swiperInstance.allowTouchMove = true;
        }
    }

    window.addEventListener('resize', () => updateSwiperTouch(swiper));
    swiper.on('update', () => updateSwiperTouch(swiper));
};
